
import './App.css';
import Weatherpage from './pages/WaeatherPage';

function App() {
  return (
   
    <div className="App">
      <Weatherpage />
    </div>
  );
}

export default App;
